import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import products from './modules/products';
import laboratorios from './modules/laboratorios';
import pedidos from './modules/pedidos';

import { DELETE_TOKEN, SET_TOKEN } from './mutations-types';

Vue.use(Vuex);

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',

    state: {
        token: localStorage.getItem('_t') || null
    },

    getters: {
        isLoggedIn: state => !!state.token
    },

    mutations: {
        [SET_TOKEN](state, token) {
            state.token = `Bearer  ${token}`;
            localStorage.setItem('_t', state.token);
        },
        [DELETE_TOKEN](state) {
            localStorage.removeItem('_t');
            state.token = null;
        }
    },
    actions: {
        deleteToken({ commit }) {
            commit(DELETE_TOKEN);
        }
    },
    modules: {
        auth,
        products,
        laboratorios,
        pedidos
    }
});
